<div class="card dialog" role="dialog" aria-labelledby="install-title">
    <div class="card-header">
        <div class="install-mark" aria-hidden="true"><i class="bi bi-phone"></i></div>
        <div>
            <span class="install-eyebrow">Vabait inmobiliaria</span>
            <h3 id="install-title">Llévanos siempre contigo</h3>
        </div>
        <button type="button" class="install-close" aria-label="Cerrar aviso" (click)="closeChild()">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
    </div>
    <div class="card-body">
        <p>Accede más rápido a tus propiedades desde cualquier dispositivo.</p>
        <div class="install-actions">
            <button type="button" class="btn install-dismiss" (click)="closeChild()">Ahora no</button>
            <button type="button" class="btn install-action" (click)="installApp()">
                Instalar app <i class="bi bi-download" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>